import React, { Fragment, useContext, useEffect, useState } from "react";
import { LineChart } from "../components";
import useAxiosInterceptors from "../../hooks/httpConfig";
import { Link } from "react-router-dom";
import { ProgrammeContext, UserContext } from "../../contexts/UserContext";

const Modal = ({ id, title, data, linkPrefix }) => {
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={`${id}Title`}
      aria-hidden="true"
    >
      <div
        className="ModalUsers-Dialog modal-dialog modal-dialog-centered"
        role="document"
      >
        <div className="ModalUsers-Content modal-content">
          <div className="modal-body">
            <div className="ModelUsers-Header">
              <h4>{title}</h4>
              <button type="button" className="Close-BTN" data-dismiss="modal">
                <i className="uil uil-multiply"></i>
              </button>
            </div>
            <div className="table-responsive">
              <table
                className="table table-striped table-bordered dt-responsive nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th scope="col">Startup</th>
                    <th scope="col">Activité</th>
                    <th scope="col">Secteur d’activité</th>
                    <th scope="col">Email Address</th>
                    <th scope="col">Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr
                      key={item._id}
                      id={`row_${index}`}
                      role="row"
                      className={index % 2 === 0 ? "odd" : "even"}
                    >
                      <td className="sorting_1">
                        <div className="D-RowUserInfo">
                          <span className="MembersList-RowUserInfoThumb"></span>
                          <a
                            href={`/${linkPrefix}/${item._id}`}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={`Voir le profile de la ${title}`}
                          >
                            {item.nom}
                          </a>
                        </div>
                      </td>
                      <td>{item.activite}</td>
                      <td>{item.secteur}</td>
                      <td>{item.email}</td>
                      <td>{item.telephone}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col">StartUp</th>
                    <th scope="col">Activité</th>
                    <th scope="col">Secteur d’activité</th>
                    <th scope="col">Email Address</th>
                    <th scope="col">Phone</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function DashboardPilote() {
  const apiInstance = useAxiosInterceptors();
  const [projet] = useContext(ProgrammeContext);
  const [user] = useContext(UserContext);

  const [startups, setStartups] = useState([]);
  const [consultants, setConsultants] = useState([]);
  const [pilotes, setPilotes] = useState([]);
  const [secteurCount, setSecteurCount] = useState(0);
  const [bienCount, setBienCount] = useState(0);
  const [pilote, setPilote] = useState({});
  const [activite, setActivite] = useState({});
  const [budget, setBudget] = useState({});
  const [devise, setDevise] = useState({});
  // valeurs statiques provisoires récupérées du backend à brancher sur les vraies fonctions de calcul
  /* ------------ */
  const [performanceTotal, setPerformanceTotal] = useState(0);
  const [financementRecu, setFinancementRecu] = useState(0);
  const [financementRestant, setFinancementRestant] = useState(0);
  const [budgetRecuConsultants, setBudgetRecuConsultants] = useState(0);
  const [budgetRestantConsultants, setBudgetRestantConsultants] = useState(0);
  /* ------------ */

  useEffect(() => {
    const secteurs = startups.map((startup) => startup.secteur);
    const uniqueSecteurs = new Set(secteurs);
    setSecteurCount(uniqueSecteurs.size);
  }, [startups]);

  useEffect(() => {
    const programme = projet?.programme?._id;
    const entreprise = user?.entreprise?._id;
    if (programme && entreprise) {
      apiInstance
        .get(`/startup/${entreprise}/findDataPilote/${programme}`)
        .then(({ data }) => {
          setStartups(data.startups);
          setConsultants(data.consultants);
          setPilotes(data.pilotes);
          setBienCount(data.countBiens);
          setPilote(data.pilote);
          setActivite(data.activite);
          setBudget(data?.budget);
          setDevise(data?.devise);
          setPerformanceTotal(data.performanceTotal ?? 0);
          setFinancementRecu(data.financementRecu ?? 0);
          setFinancementRestant(data.financementRestant ?? 0);
          setBudgetRecuConsultants(data.budgetRecuConsultants ?? 0);
          setBudgetRestantConsultants(data.budgetRestantConsultants ?? 0);
        });
    }
  }, [apiInstance, projet?.programme?._id, user?.entreprise?._id]);

  return (
    <Fragment>
      <div className="Content-Container">
        <div className="PageHeader">
          <div className="row">
            <div className="col-md-4">
              <h3 className="PageHeader-Title">Dashboard</h3>
            </div>
            <div className="col-md-8">
              <div className="FilterForm">
                <div className="FilterRow">
                  {/* START INPUT ROW */}
                  <div className="Input-Row Input-Select">
                    <select
                      className="SelectFilter"
                      name=""
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Chiffre d’affaires
                      </option>
                      <option vlaue="1">Chiffre d’affaire 1</option>
                      <option vlaue="2">Chiffre d’affaire 2</option>
                      <option vlaue="3">Chiffre d’affaire 3</option>
                    </select>
                  </div>
                  {/* END INPUT ROW */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <LineChart />
        <div className="StatsBox">
          <div className="row">
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Startups</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb"></div>
                    <div
                      className="StartupBOX-Thumb ShowMore"
                      data-toggle="modal"
                      data-target="#ModalStartups"
                    >
                      +{startups.length}
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-2 info-box">
                    <div className="icon-circle icon-count">
                      <i className="uil uil-briefcase"></i>
                      <span className="count">{secteurCount}</span>
                    </div>
                    <label>Secteurs d’activité</label>
                  </div>

                  <div className="BOX-Side-2 info-box">
                    <div className="icon-circle icon-count">
                      <i className="uil uil-parcel"></i>
                      <span className="count">{bienCount}</span>
                    </div>
                    <label>Biens</label>
                  </div>

                  <div className="BOX-Side-2 info-box full-width">
                    <div className="icon-circle icon-total">
                      <i className="uil uil-chart-line"></i>
                    </div>
                    <div className="performance-total">
                      <label>Performances</label>
                      <span className="total">{`${performanceTotal.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    </div>
                  </div>
                </div>
                <div className="BOX-Footer">
                  <div className="BOX-Side-2">
                    <label className="BOX-Label">
                      <strong>Financements reçus</strong>
                    </label>
                    <label className="BOX-Label">Restants</label>
                  </div>
                  <div className="BOX-Side-2">
                    <span className="Total">{`${financementRecu.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    <span className="Investi">{`${financementRestant.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Consultants</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb"></div>
                    <div
                      className="StartupBOX-Thumb ShowMore"
                      data-toggle="modal"
                      data-target="#ModalConsultants"
                    >
                      +{consultants.length}
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <div className="BOX-Side-Icon">
                        <i className="uil uil-briefcase-alt"></i>
                      </div>
                      <span>
                        {activite.Done} sur {activite.total}
                      </span>
                      <label>Activité effectuées</label>
                    </div>
                  </div>
                </div>
                <div className="BOX-Footer">
                  <div className="BOX-Side-2">
                    <label className="BOX-Label">
                      <strong>Budgets reçus</strong>
                    </label>
                    <label className="BOX-Label">Restants</label>
                  </div>
                  <div className="BOX-Side-2">
                    <span className="Investi">{`${budgetRecuConsultants.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                    <span className="Total">{`${budgetRestantConsultants.toLocaleString("fr-FR")} ${devise?.symbole ?? ""}`}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="Purple-BOX DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">Pilotes / Bailleurs</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb"></div>
                    <div
                      className="StartupBOX-Thumb ShowMore"
                      data-toggle="modal"
                      data-target="#ModalManagers"
                    >
                      +{pilotes.length}
                    </div>
                  </div>
                </div>
                <div className="BOX-Content">
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget prévu</label>
                      <span>{`${budget?.totalBudget} ${devise?.symbole}`}</span>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget investi</label>
                      <span>{`${budget?.totalDepenses} ${devise?.symbole}`}</span>
                    </div>
                  </div>
                  <div className="BOX-Side-1">
                    <div className="BOX-Side-Content">
                      <label>Budget restant</label>
                      <span>{`${(budget?.totalBudget || 0) - (budget?.totalDepenses || 0)} ${devise?.symbole}`}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="DashboardStats-BOX">
                <div className="BOX-Header">
                  <h4 className="BOX-Title">A propos</h4>
                  <div className="StartupsBOX-List">
                    <div className="StartupBOX-Thumb ShowMore">
                      <i className="uil uil-user-md"></i>
                    </div>
                  </div>
                </div>
                <div className="m-4">
                  {pilote?.utilisateur?.prenom && pilote?.utilisateur?.nom && (
                    <div className="mb-2">
                      <strong>Consultant :</strong> {pilote.utilisateur.prenom}{" "}
                      {pilote.utilisateur.nom}
                    </div>
                  )}

                  {pilote?.nom && (
                    <div className="mb-2">
                      <strong>Nom :</strong> {pilote.nom}
                    </div>
                  )}

                  {pilote?.activite && (
                    <div className="mb-2">
                      <strong>Activité :</strong>{" "}
                      {pilote.activite.replace("/", " / ")}
                    </div>
                  )}

                  {pilote?.secteur && (
                    <div className="mb-2">
                      <strong>Secteur :</strong> {pilote.secteur}
                    </div>
                  )}

                  {pilote?.lieu && (
                    <div className="mb-2">
                      <strong>Lieu :</strong> {pilote.lieu}
                    </div>
                  )}

                  {pilote?.creation && (
                    <div className="mb-2">
                      <strong>Date de création :</strong>{" "}
                      {new Date(pilote.creation).toLocaleDateString("fr-FR")}
                    </div>
                  )}

                  {pilote?.team && Array.isArray(pilote.team) && (
                    <div className="mb-2">
                      <strong>Equipe :</strong> {pilote.team.length}
                    </div>
                  )}
                  {pilote?._id && (
                    <Link
                      to={`/startup/pilote/${pilote._id}`}
                      className="Menu-Link"
                    >
                      Voir plus
                    </Link>
                  )}
                </div>
                <div className="BOX-Footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        id="ModalStartups"
        title="Startups"
        data={startups}
        linkPrefix="startup"
      />
      <Modal
        id="ModalManagers"
        title="Pilotes / Bailleurs"
        data={pilotes}
        linkPrefix="startup/pilote"
      />
      <Modal
        id="ModalConsultants"
        title="Consultants"
        data={consultants}
        linkPrefix="startup/consultant"
      />
    </Fragment>
  );
}

// export default Dashboard;
